import { Navigate, useLocation } from 'react-router-dom';
import { useUserRole } from './useUserRole';
import { canAccess, defaultRouteForRole } from './roles';

function PrivateRoute({ children, routeKey }) {
    const { user, rol, loading } = useUserRole();
    const location = useLocation();

    if (loading || user === undefined) return null;

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (routeKey && rol && !canAccess(rol, routeKey)) {
        const fallback = defaultRouteForRole(rol);
        return <Navigate to={fallback} replace />;
    }

    return children;
}

export default PrivateRoute;